var map = {
	"./dx-accordion-group.entry.js": [
		90964,
		"node_modules_dvag_design-system_dist_esm_dx-accordion-group_entry_js"
	],
	"./dx-accordion-legend_2.entry.js": [
		25519,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"default-node_modules_dvag_design-system_dist_esm_debounce-DTyXyk9F_js-node_modules_dvag_desig-13a745",
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-accordion-legend_2_entry_js"
	],
	"./dx-accordion.entry.js": [
		96458,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-accordion_entry_js"
	],
	"./dx-alert.entry.js": [
		14030,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"default-node_modules_dvag_design-system_dist_esm_debounce-DTyXyk9F_js-node_modules_dvag_desig-13a745",
		"node_modules_dvag_design-system_dist_esm_dx-alert_entry_js"
	],
	"./dx-announcement-bar.entry.js": [
		77773,
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-announcement-bar_entry_js"
	],
	"./dx-app.entry.js": [
		90995,
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-app_entry_js"
	],
	"./dx-breadcrumb-item.entry.js": [
		51375,
		"node_modules_dvag_design-system_dist_esm_dx-breadcrumb-item_entry_js"
	],
	"./dx-breadcrumb.entry.js": [
		80091,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-breadcrumb_entry_js"
	],
	"./dx-button_2.entry.js": [
		99079,
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-button_2_entry_js"
	],
	"./dx-calendar.entry.js": [
		11112,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"default-node_modules_dvag_design-system_dist_esm_date_util-CwKiV0Ft_js",
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-calendar_entry_js"
	],
	"./dx-card-collapsable.entry.js": [
		21181,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"node_modules_dvag_design-system_dist_esm_dx-card-collapsable_entry_js"
	],
	"./dx-card-content_2.entry.js": [
		21561,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-card-content_2_entry_js"
	],
	"./dx-card-image.entry.js": [
		29084,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-card-image_entry_js"
	],
	"./dx-card.entry.js": [
		25900,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"node_modules_dvag_design-system_dist_esm_dx-card_entry_js"
	],
	"./dx-chart-sample.entry.js": [
		23079,
		"node_modules_dvag_design-system_dist_esm_dx-chart-sample_entry_js"
	],
	"./dx-checkbox-group.entry.js": [
		5753,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-checkbox-group_entry_js"
	],
	"./dx-checkbox_2.entry.js": [
		77054,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-checkbox_2_entry_js"
	],
	"./dx-chevron.entry.js": [
		96491,
		"node_modules_dvag_design-system_dist_esm_dx-chevron_entry_js"
	],
	"./dx-clear-button_9.entry.js": [
		19918,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-clear-button_9_entry_js"
	],
	"./dx-combobox.entry.js": [
		21201,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-combobox_entry_js"
	],
	"./dx-container.entry.js": [
		48675,
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-container_entry_js"
	],
	"./dx-content-switcher_2.entry.js": [
		8700,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"node_modules_dvag_design-system_dist_esm_dx-content-switcher_2_entry_js"
	],
	"./dx-cookie-banner.entry.js": [
		92851,
		"node_modules_dvag_design-system_dist_esm_dx-cookie-banner_entry_js"
	],
	"./dx-cookie-choice.entry.js": [
		57986,
		"node_modules_dvag_design-system_dist_esm_dx-cookie-choice_entry_js"
	],
	"./dx-date-input.entry.js": [
		38855,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"default-node_modules_dvag_design-system_dist_esm_date_util-CwKiV0Ft_js",
		"default-node_modules_dvag_design-system_dist_esm_async-DIhi50yK_js-node_modules_dvag_design-s-dd8845",
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-date-input_entry_js"
	],
	"./dx-date-range.entry.js": [
		1954,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"default-node_modules_dvag_design-system_dist_esm_date_util-CwKiV0Ft_js",
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-date-range_entry_js"
	],
	"./dx-date-time-range.entry.js": [
		74170,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"default-node_modules_dvag_design-system_dist_esm_date_util-CwKiV0Ft_js",
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-date-time-range_entry_js"
	],
	"./dx-date-time-segment.entry.js": [
		75014,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"default-node_modules_dvag_design-system_dist_esm_date_util-CwKiV0Ft_js",
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-date-time-segment_entry_js"
	],
	"./dx-date-time.entry.js": [
		87934,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"default-node_modules_dvag_design-system_dist_esm_date_util-CwKiV0Ft_js",
		"default-node_modules_dvag_design-system_dist_esm_async-DIhi50yK_js-node_modules_dvag_design-s-dd8845",
		"node_modules_dvag_design-system_dist_esm_dx-date-time_entry_js"
	],
	"./dx-donut-chart.entry.js": [
		20961,
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-donut-chart_entry_js"
	],
	"./dx-dropdown-option.entry.js": [
		72673,
		"node_modules_dvag_design-system_dist_esm_dx-dropdown-option_entry_js"
	],
	"./dx-dropdown_2.entry.js": [
		22334,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"default-node_modules_dvag_design-system_dist_esm_element-id-handling-YJNGfAdl_js-node_modules-da23bf",
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-dropdown_2_entry_js"
	],
	"./dx-element-swapper.entry.js": [
		12015,
		"node_modules_dvag_design-system_dist_esm_dx-element-swapper_entry_js"
	],
	"./dx-error-page.entry.js": [
		39432,
		"node_modules_dvag_design-system_dist_esm_dx-error-page_entry_js"
	],
	"./dx-error-summary-item.entry.js": [
		90079,
		"node_modules_dvag_design-system_dist_esm_dx-error-summary-item_entry_js"
	],
	"./dx-error-summary-page.entry.js": [
		87791,
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-error-summary-page_entry_js"
	],
	"./dx-error-summary.entry.js": [
		96171,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"default-node_modules_dvag_design-system_dist_esm_breakpoint-aware-rOOUjKwb_js-node_modules_dv-6c92ba",
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-error-summary_entry_js"
	],
	"./dx-expanded.entry.js": [
		21087,
		"node_modules_dvag_design-system_dist_esm_dx-expanded_entry_js"
	],
	"./dx-fd-outline-box.entry.js": [
		83535,
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-fd-outline-box_entry_js"
	],
	"./dx-fd-separator.entry.js": [
		18026,
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-fd-separator_entry_js"
	],
	"./dx-flyout_6.entry.js": [
		84300,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"default-node_modules_dvag_design-system_dist_esm_element-id-handling-YJNGfAdl_js-node_modules-7f34d4",
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-flyout_6_entry_js"
	],
	"./dx-footer.entry.js": [
		82541,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-footer_entry_js"
	],
	"./dx-golden-stage.entry.js": [
		79888,
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-golden-stage_entry_js"
	],
	"./dx-grid.entry.js": [
		57598,
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-grid_entry_js"
	],
	"./dx-header-app-favorites-app.entry.js": [
		96471,
		"node_modules_dvag_design-system_dist_esm_dx-header-app-favorites-app_entry_js"
	],
	"./dx-header-app-favorites-sidebar-content_2.entry.js": [
		38261,
		"node_modules_dvag_design-system_dist_esm_dx-header-app-favorites-sidebar-content_2_entry_js"
	],
	"./dx-header-app-favorites.entry.js": [
		14093,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-header-app-favorites_entry_js"
	],
	"./dx-header-application-name_3.entry.js": [
		76548,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-header-application-name_3_entry_js"
	],
	"./dx-header-menu-button_2.entry.js": [
		43781,
		"node_modules_dvag_design-system_dist_esm_dx-header-menu-button_2_entry_js"
	],
	"./dx-header-menu-custom.entry.js": [
		49411,
		"node_modules_dvag_design-system_dist_esm_dx-header-menu-custom_entry_js"
	],
	"./dx-header-menu-group.entry.js": [
		43281,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-header-menu-group_entry_js"
	],
	"./dx-header-menu-item_4.entry.js": [
		81748,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"default-node_modules_dvag_design-system_dist_esm_element-id-handling-YJNGfAdl_js-node_modules-e311cb",
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-header-menu-item_4_entry_js"
	],
	"./dx-header-menu-link.entry.js": [
		44688,
		"node_modules_dvag_design-system_dist_esm_dx-header-menu-link_entry_js"
	],
	"./dx-header-navigation-item.entry.js": [
		2688,
		"default-node_modules_dvag_design-system_dist_esm_element-id-handling-YJNGfAdl_js-node_modules-e311cb",
		"node_modules_dvag_design-system_dist_esm_dx-header-navigation-item_entry_js"
	],
	"./dx-header-user-sidebar-content.entry.js": [
		55086,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-header-user-sidebar-content_entry_js"
	],
	"./dx-header-user.entry.js": [
		28415,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-header-user_entry_js"
	],
	"./dx-header.entry.js": [
		85751,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-header_entry_js"
	],
	"./dx-hero-image.entry.js": [
		37962,
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-hero-image_entry_js"
	],
	"./dx-horizontal-grow-box.entry.js": [
		26992,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"node_modules_dvag_design-system_dist_esm_dx-horizontal-grow-box_entry_js"
	],
	"./dx-icon_2.entry.js": [
		32606,
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-icon_2_entry_js"
	],
	"./dx-info.entry.js": [
		51686,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"node_modules_dvag_design-system_dist_esm_dx-info_entry_js"
	],
	"./dx-input-row-layout_3.entry.js": [
		72230,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-input-row-layout_3_entry_js"
	],
	"./dx-internal-accordion.entry.js": [
		35112,
		"node_modules_dvag_design-system_dist_esm_dx-internal-accordion_entry_js"
	],
	"./dx-internal-date-time.entry.js": [
		62012,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-internal-date-time_entry_js"
	],
	"./dx-internal-selectable-button.entry.js": [
		66545,
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-internal-selectable-button_entry_js"
	],
	"./dx-internal-wizard-step.entry.js": [
		88134,
		"node_modules_dvag_design-system_dist_esm_dx-internal-wizard-step_entry_js"
	],
	"./dx-legend.entry.js": [
		28447,
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-legend_entry_js"
	],
	"./dx-list-section.entry.js": [
		59972,
		"node_modules_dvag_design-system_dist_esm_dx-list-section_entry_js"
	],
	"./dx-loading-indicator-overlay.entry.js": [
		49753,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"node_modules_dvag_design-system_dist_esm_dx-loading-indicator-overlay_entry_js"
	],
	"./dx-logo-bildmarke.entry.js": [
		57323,
		"node_modules_dvag_design-system_dist_esm_dx-logo-bildmarke_entry_js"
	],
	"./dx-logo-wortmarke.entry.js": [
		81204,
		"node_modules_dvag_design-system_dist_esm_dx-logo-wortmarke_entry_js"
	],
	"./dx-media-query-display.entry.js": [
		60994,
		"node_modules_dvag_design-system_dist_esm_dx-media-query-display_entry_js"
	],
	"./dx-media-query-value_2.entry.js": [
		38468,
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-media-query-value_2_entry_js"
	],
	"./dx-multi-dropdown-option.entry.js": [
		6417,
		"node_modules_dvag_design-system_dist_esm_dx-multi-dropdown-option_entry_js"
	],
	"./dx-multi-dropdown.entry.js": [
		24111,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-multi-dropdown_entry_js"
	],
	"./dx-multi-select-item.entry.js": [
		77360,
		"node_modules_dvag_design-system_dist_esm_dx-multi-select-item_entry_js"
	],
	"./dx-multi-select.entry.js": [
		44866,
		"default-node_modules_dvag_design-system_dist_esm_element-id-handling-YJNGfAdl_js-node_modules-ce83d1",
		"node_modules_dvag_design-system_dist_esm_dx-multi-select_entry_js"
	],
	"./dx-notification-banner.entry.js": [
		10788,
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-notification-banner_entry_js"
	],
	"./dx-notification-bar.entry.js": [
		32465,
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-notification-bar_entry_js"
	],
	"./dx-notification-toast.entry.js": [
		3151,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"default-node_modules_dvag_design-system_dist_esm_debounce-DTyXyk9F_js-node_modules_dvag_desig-13a745",
		"default-node_modules_dvag_design-system_dist_esm_breakpoint-aware-rOOUjKwb_js-node_modules_dv-3a4d06",
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-notification-toast_entry_js"
	],
	"./dx-number-input.entry.js": [
		50706,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-number-input_entry_js"
	],
	"./dx-number-paginator_4.entry.js": [
		2330,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"default-node_modules_dvag_design-system_dist_esm_element-id-handling-YJNGfAdl_js-node_modules-da23bf",
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-number-paginator_4_entry_js"
	],
	"./dx-overflow-menu-item.entry.js": [
		94912,
		"node_modules_dvag_design-system_dist_esm_dx-overflow-menu-item_entry_js"
	],
	"./dx-overflow-menu.entry.js": [
		32498,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"default-node_modules_dvag_design-system_dist_esm_element-id-handling-YJNGfAdl_js-node_modules-7f34d4",
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-overflow-menu_entry_js"
	],
	"./dx-paginator_2.entry.js": [
		93094,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-paginator_2_entry_js"
	],
	"./dx-partner-logo.entry.js": [
		91752,
		"node_modules_dvag_design-system_dist_esm_dx-partner-logo_entry_js"
	],
	"./dx-password-criteria-display.entry.js": [
		49770,
		"node_modules_dvag_design-system_dist_esm_dx-password-criteria-display_entry_js"
	],
	"./dx-password-criteria.entry.js": [
		76881,
		"node_modules_dvag_design-system_dist_esm_dx-password-criteria_entry_js"
	],
	"./dx-password-display-control_2.entry.js": [
		45841,
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-password-display-control_2_entry_js"
	],
	"./dx-password-input.entry.js": [
		13850,
		"node_modules_dvag_design-system_dist_esm_dx-password-input_entry_js"
	],
	"./dx-placeholder.entry.js": [
		31989,
		"node_modules_dvag_design-system_dist_esm_dx-placeholder_entry_js"
	],
	"./dx-process-header-item.entry.js": [
		64111,
		"node_modules_dvag_design-system_dist_esm_dx-process-header-item_entry_js"
	],
	"./dx-process-header.entry.js": [
		29563,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-process-header_entry_js"
	],
	"./dx-representative-info.entry.js": [
		32568,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-representative-info_entry_js"
	],
	"./dx-scrollable-shadow_2.entry.js": [
		73657,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"node_modules_dvag_design-system_dist_esm_dx-scrollable-shadow_2_entry_js"
	],
	"./dx-section-headline.entry.js": [
		74540,
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-section-headline_entry_js"
	],
	"./dx-simple-grow-box.entry.js": [
		91850,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-simple-grow-box_entry_js"
	],
	"./dx-single-select_2.entry.js": [
		38518,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"default-node_modules_dvag_design-system_dist_esm_element-id-handling-YJNGfAdl_js-node_modules-ce83d1",
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-single-select_2_entry_js"
	],
	"./dx-site-navigation-menu-error-summary.entry.js": [
		94732,
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-site-navigation-menu-error-summary_entry_js"
	],
	"./dx-site-navigation-menu-item.entry.js": [
		47000,
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-site-navigation-menu-item_entry_js"
	],
	"./dx-site-navigation-menu.entry.js": [
		24202,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"default-node_modules_dvag_design-system_dist_esm_breakpoint-aware-rOOUjKwb_js-node_modules_dv-6c92ba",
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-site-navigation-menu_entry_js"
	],
	"./dx-site-navigation-scope.entry.js": [
		64165,
		"node_modules_dvag_design-system_dist_esm_dx-site-navigation-scope_entry_js"
	],
	"./dx-site-navigation.entry.js": [
		28712,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"node_modules_dvag_design-system_dist_esm_dx-site-navigation_entry_js"
	],
	"./dx-skeleton.entry.js": [
		3713,
		"node_modules_dvag_design-system_dist_esm_dx-skeleton_entry_js"
	],
	"./dx-slide-show.entry.js": [
		34547,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"default-node_modules_dvag_design-system_dist_esm_breakpoint-aware-rOOUjKwb_js-node_modules_dv-3a4d06",
		"node_modules_dvag_design-system_dist_esm_dx-slide-show_entry_js"
	],
	"./dx-slider.entry.js": [
		23207,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-slider_entry_js"
	],
	"./dx-sort_2.entry.js": [
		63711,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"node_modules_dvag_design-system_dist_esm_dx-sort_2_entry_js"
	],
	"./dx-spacer.entry.js": [
		21446,
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-spacer_entry_js"
	],
	"./dx-switch.entry.js": [
		36146,
		"node_modules_dvag_design-system_dist_esm_dx-switch_entry_js"
	],
	"./dx-tab-bar.entry.js": [
		39983,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"node_modules_dvag_design-system_dist_esm_dx-tab-bar_entry_js"
	],
	"./dx-tab-dropdown.entry.js": [
		20245,
		"default-node_modules_dvag_design-system_dist_esm_element-id-handling-YJNGfAdl_js-node_modules-da23bf",
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-tab-dropdown_entry_js"
	],
	"./dx-tab-page.entry.js": [
		23163,
		"node_modules_dvag_design-system_dist_esm_dx-tab-page_entry_js"
	],
	"./dx-table-cell.entry.js": [
		96209,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-table-cell_entry_js"
	],
	"./dx-table-footer.entry.js": [
		97442,
		"node_modules_dvag_design-system_dist_esm_dx-table-footer_entry_js"
	],
	"./dx-table-header-item.entry.js": [
		36518,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-table-header-item_entry_js"
	],
	"./dx-table-header.entry.js": [
		85700,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-table-header_entry_js"
	],
	"./dx-table-row.entry.js": [
		30345,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-table-row_entry_js"
	],
	"./dx-table.entry.js": [
		42132,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-table_entry_js"
	],
	"./dx-text-area.entry.js": [
		88491,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-text-area_entry_js"
	],
	"./dx-text-input.entry.js": [
		72808,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-text-input_entry_js"
	],
	"./dx-text-list.entry.js": [
		44218,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"node_modules_dvag_design-system_dist_esm_dx-text-list_entry_js"
	],
	"./dx-text.entry.js": [
		8417,
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-text_entry_js"
	],
	"./dx-toggle.entry.js": [
		47630,
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-toggle_entry_js"
	],
	"./dx-user-avatar.entry.js": [
		67219,
		"node_modules_dvag_design-system_dist_esm_dx-user-avatar_entry_js"
	],
	"./dx-wizard-step.entry.js": [
		19936,
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-wizard-step_entry_js"
	],
	"./dx-wizard.entry.js": [
		68009,
		"default-node_modules_dvag_design-system_dist_esm_misc-util-EDI7GEG-_js",
		"common",
		"node_modules_dvag_design-system_dist_esm_dx-wizard_entry_js"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 83675;
module.exports = webpackAsyncContext;